// Register GSAP plugin
gsap.registerPlugin(ScrollTrigger);

// Function to animate type elements in each panel
function animatePanel(panelSelector) {
  const panel = document.querySelector(panelSelector);

  if (!panel) return;

  // Use GSAP matchMedia to apply different ScrollTrigger settings for mobile and desktop
  ScrollTrigger.matchMedia({
    // Desktop and larger screens
    "(min-width: 541px)": function () {
      gsap.timeline({
        scrollTrigger: {
          trigger: panel,
          start: "top center", // Start when the panel enters the center of the viewport
          end: "top top", // End when the panel exits the center of the viewport
          scrub: true,
          once: true,
        },
      })
        .fromTo(
          panel.querySelector("h2.firsth2"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 }
        )
        .fromTo(
          panel.querySelector("h3"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 },
          "<0.2"
        )
        .fromTo(
          panel.querySelector("h2.lasth2"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 },
          "<0.4"
        )
        .fromTo(
          panel.querySelector("a"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 },
          "<0.6"
        );
    },

    // Mobile and smaller screens
    "(max-width: 540px)": function () {
      gsap.timeline({
        scrollTrigger: {
          trigger: panel,
          start: "top 80%", // Adjust start position for mobile screens
          end: "top 40%", // End position remains the same
          scrub: true,
          once: true,
        },
      })
        .fromTo(
          panel.querySelector("h2.firsth2"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 }
        )
        .fromTo(
          panel.querySelector("h3"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 },
          "<0.2"
        )
        .fromTo(
          panel.querySelector("h2.lasth2"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 },
          "<0.4"
        )
        .fromTo(
          panel.querySelector("a"),
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1 },
          "<0.6"
        );
    }
  });
}

// Animate each panel
animatePanel(".thick-panel.xx-red");
animatePanel(".thick-panel.x-red");
animatePanel(".thick-panel.pro-red");
